import React from 'react';
export default function Privacy() {
  return (
    <div className="page-wrapper" style={{paddingBottom:60}}>
      <div style={{background:'linear-gradient(135deg,#0D1421 0%,#0a2a4a 50%,#0D1421 100%)',padding:'60px 20px',textAlign:'center'}}>
        <div style={{fontSize:40,marginBottom:12}}>🔒</div>
        <h1 style={{fontSize:34,fontWeight:800,marginBottom:12}}>سياسة الخصوصية</h1>
        <p style={{color:'var(--color-text-muted)',fontSize:15}}>آخر تحديث: مايو 2026</p>
      </div>
      <div className="container" style={{maxWidth:800,paddingTop:48}}>
        {[
          {t:'1. مقدمة',d:'تلتزم منصة SPORTIX بحماية خصوصية مستخدميها. توضح هذه السياسة كيفية جمع معلوماتك الشخصية واستخدامها وحمايتها عند استخدام منصتنا.'},
          {t:'2. المعلومات التي نجمعها',d:'نقوم بجمع المعلومات التي تقدمها مباشرة مثل الاسم والبريد الإلكتروني ورقم الهاتف والسيرة الذاتية. كما نجمع معلومات تلقائية مثل عنوان IP وبيانات الاستخدام وملفات تعريف الارتباط.'},
          {t:'3. كيف نستخدم معلوماتك',d:'نستخدم معلوماتك لتشغيل المنصة وتحسينها، وإرسال إشعارات متعلقة بالخدمة، ومطابقتك مع الفرص الوظيفية المناسبة، والتواصل معك بشأن حسابك.'},
          {t:'4. مشاركة المعلومات',d:'لا نبيع معلوماتك الشخصية لأطراف ثالثة. قد نشارك معلوماتك مع المؤسسات والأندية عند تقديمك لوظيفة أو طلب خدمة، وذلك بموافقتك الصريحة.'},
          {t:'5. حماية البيانات',d:'نستخدم تقنيات تشفير متقدمة لحماية بياناتك. يتم تخزين جميع البيانات على خوادم آمنة مع تطبيق أعلى معايير الحماية الرقمية.'},
          {t:'6. حقوقك',d:'لديك الحق في الوصول إلى بياناتك الشخصية وتصحيحها أو حذفها في أي وقت. يمكنك ممارسة هذه الحقوق من خلال التواصل معنا عبر البريد الإلكتروني.'},
          {t:'7. التواصل',d:'إذا كان لديك أي أسئلة حول سياسة الخصوصية، يرجى التواصل معنا على: privacy@sportix.ae'},
        ].map((s,i)=>(
          <div key={i} className="card" style={{padding:28,marginBottom:16}}>
            <h3 style={{fontSize:18,fontWeight:700,marginBottom:12,color:'var(--color-primary)'}}>{s.t}</h3>
            <p style={{color:'var(--color-text-muted)',lineHeight:1.9,fontSize:14}}>{s.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
